<ng-container *finLet="template$ | finMap: 'loading' | async as isLoading">
  @if (isLoading) {
    <fcom-loader [loaderType]="LoaderTheme.INLINE" />
  } @else {
    <fin-apis-global-status [order$]="order$" />
    <div class="pr-small-x rounded-large mr-medium-b border white-bg">
      <fin-cms-json-content [template$]="template$ | finMap: 'data'" />
    </div>
    <ul class="unstyled">
      <li
        *ngFor="let passenger$ of order$ | finMap: 'passengers' | finObsToArray"
        class="pr-small rounded-large border mr-medium-b white-bg"
      >
        <fin-apis-passenger
          [requiredTravelRequirements]="requiredTravelRequirements$ | async"
          [passenger$]="passenger$"
          (openForm)="openForm($event)"
        />
      </li>

      <li *ngIf="showEmergencyContact$ | async">
        <h2 class="font-heading-2 nordic-blue-900-text mr-small-b">
          {{ 'MMB.apis.emergencyContactDetails' | finLocalization }}
        </h2>

        <p class="mr-small-b">{{ 'MMB.apis.emergencyContactDetailsRequired' | finLocalization }}</p>

        <div class="pr-small rounded-large mr-medium-b border white-bg">
          <h3 class="font-heading-3 nordic-blue-900-text mr-small-b">
            {{ 'MMB.labels.emergencyContactDetails' | finLocalization }}
          </h3>

          <fin-mmb-emergency-contact [trackApis]="true" class="block" [emergencyContact]="emergencyContact$ | async" />
        </div>
      </li>
    </ul>

    <fin-subview
      #subview
      [subviewName]="subviewName"
      (closeSubViewEvent)="onCloseSubview()"
      [subviewContext]="TRACKING_CONTEXT"
    >
      <ng-container ngProjectAs="header">
        <fin-cms-global-disruption-banner />
        <fin-sub-header
          [hasBasket]="false"
          [isBasketDisabled]="true"
          [hasActiveBasketState]="false"
          [hasBasketActionInMobileOnly]="true"
          [backgroundColorClass]="'nordic-blue-900-bg'"
        >
          <button
            class="back-button focus-inset"
            [attr.title]="'ancillaries.backToServices' | finLocalization"
            (click)="closeSubview()"
          >
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_LEFT" />
            <span class="inline-block block pr-small-l">
              <span class="block details white-text font-body-1 bold-type">{{
                'MMB.apis.passenger.backToSelection' | finLocalization
              }}</span>
            </span>
          </button>
        </fin-sub-header>
      </ng-container>

      <ng-container ngProjectAs="main-content">
        <fin-mmb-unsaved-changes
          [unsavedChangesModalOpen]="unsavedChangesModalOpen"
          (leaveWithoutSaving)="leaveWithoutSaving()"
          (continueEditing)="continueEditing()"
        />
        <div class="subview-content-sub-wrapper grey-25-bg scroll" *ngIf="subview.visible$ | async">
          <main class="grid-max-width grid-col-12 grow--min">
            <div class="col-f sm-col-3-10">
              <fin-apis-pax-form
                [labelledBy]="subview.labelledBy"
                [passenger]="selectedPassenger$ | async"
                [requiredForms]="requiredTravelRequirements$ | async"
                [addresses]="addresses$ | async"
                (closeForm)="closeSubview()"
                (formDirtyStatus)="setApisPaxFormDirtyStatus($event)"
              />
            </div>
          </main>
        </div>
      </ng-container>
    </fin-subview>
  }
</ng-container>
